export default "__VITE_ASSET__nrU9CyEC__"